// Empresas permitidas por el nodo/estructura activo (o todas si no hay nodo)
export function scopedCompanies(user, companies) {
  const scids = user?.structure_company_ids;
  if (Array.isArray(scids)) {
    const allowed = new Set(scids);
    return companies.filter(c => allowed.has(c.id));
  }
  return companies;
}

// Empresa por defecto al crear, respetando el nodo activo
export function defaultCompanyId(user) {
  const scids = user?.structure_company_ids;
  const active = user?.active_company_id || user?.company_id || "";
  if (Array.isArray(scids)) {
    if (active && scids.includes(active)) return active;
    return scids.length === 1 ? scids[0] : "";
  }
  if (user?.role === "super_admin") return active;
  return active || (user?.companies?.length === 1 ? user.companies[0] : "");
}
